<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <input type="text" (keyup)="filter($event)">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <div class="flowmeters">
      @for (flowmeter of displayedFlowmeters; track flowmeter) {
        <div class="flowmeter">
          <div class="logo">
            <img src="assets/images/flowmeter.png"/>
            <a>{{ flowmeter.flowmeterId }}</a>
          </div>
          <div class="info">
            <a>{{ 'FLOWMETER.NAME' | translate }}: {{ flowmeter.flowmeterName }}</a>
            <a>{{ 'FLOWMETER.MODEL' | translate }}: {{ flowmeter.flowmetermodelName }}</a>
            <a>{{ 'FLOWMETER.FIELD_PROTOCOL' | translate }}: {{ flowmeter.fieldprotocolName }}</a>
          </div>
          <div class="add" (click)="addFlowmeter(flowmeter)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>